const appLogger = global.log.child({
    name: 'APP',
});

function formatMetaData({ listingId = null, context = '' }) {
    return {
        listingId,
        context,
    };
}

// TODO: refactor to DRY up code
// ex: log(type=error);
function logError({
    message, listingId, context,
}) {
    const meta = formatMetaData({ listingId, context });

    appLogger.error(meta, message);
}

function logInfo({
    message, listingId, context,
}) {
    const meta = formatMetaData({ listingId, context });

    appLogger.info(meta, message);
}

export default {
    logger: appLogger,
    logError,
    logInfo,
};
